import * as THREE from 'three';
import EventDispatcher from "../common/EventDispatcher";
import { Global } from "../common/global";

export default class Sounds {
    /**
     * Initializes an AICar instance.
     * @param {THREE.Scene} scene - The scene where the car will be added.
     */
    constructor(scene, camera) {
        this.scene = scene;
        this.camera= camera;
    }
    init() {
        this.events = EventDispatcher.getObj();
        this.events.addEventListener("SOUND_EVENTS", this.onEvents.bind(this));

        
    }
    onEvents(data){
        switch (data['message']['event_type']) {
            case "init_sounds":
                this.createSounds();
                break;
            case "play_sound":
                this.playSound(data['message']['data']);
                break;
        }
    }
    playSound(data){
        this[`${data['sndKey']}TI`] && clearInterval(this[`${data['sndKey']}TI`]);

        if(!Global.soundEnabled) return false;
        if (!this[`${data['sndKey']}Snd`].getLoop()) {
            if(!this[`${data['sndKey']}Snd`].isPlaying || data['sndKey'] !=='hit'){
                this[`${data['sndKey']}Snd`].stop();
                this[`${data['sndKey']}Snd`].setVolume(0.5)
                this[`${data['sndKey']}Snd`].play();
            }
          
        }
        if (!this[`${data['sndKey']}Snd`].isPlaying && this[`${data['sndKey']}Snd`].getLoop()) {
            this[`${data['sndKey']}Snd`].setVolume(0.5)
            this[`${data['sndKey']}Snd`].play();
        }

    }
  
    createSounds(){
        this.listener = new THREE.AudioListener();
        this.camera.add(this.listener);

     
        this.clickSnd = new THREE.Audio(this.listener);
        this.clickSnd.setBuffer(Global.assets['sounds']['click']['asset']);
        this.clickSnd.setLoop(false); // Set whether the audio should loop
        this.clickSnd.setVolume(0.5); // Set the volume (0 to 1)

        this.cheerSnd = new THREE.Audio(this.listener);
        this.cheerSnd.setBuffer(Global.assets['sounds']['cheer']['asset']);
        this.cheerSnd.setLoop(false); // Set whether the audio should loop
        this.cheerSnd.setVolume(0.5); // Set the volume (0 to 1)

        this.selectSnd = new THREE.Audio(this.listener);
        this.selectSnd.setBuffer(Global.assets['sounds']['select']['asset']);
        this.selectSnd.setLoop(false); // Set whether the audio should loop
        this.selectSnd.setVolume(0.5); // Set the volum
     
        this.countSnd = new THREE.Audio(this.listener);
        this.countSnd.setBuffer(Global.assets['sounds']['count']['asset']);
        this.countSnd.setLoop(false); // Set whether the audio should loop
        this.countSnd.setVolume(0.5); // Set the volum

        this.FinishLineSnd = new THREE.Audio(this.listener);
        this.FinishLineSnd.setBuffer(Global.assets['sounds']['FinishLine']['asset']);
        this.FinishLineSnd.setLoop(false); // Set whether the audio should loop
        this.FinishLineSnd.setVolume(0.5); // Set the volum
        

        this.goSnd = new THREE.Audio(this.listener);
        this.goSnd.setBuffer(Global.assets['sounds']['Go']['asset']);
        this.goSnd.setLoop(false); // Set whether the audio should loop
        this.goSnd.setVolume(0.5); // Set the volum

        this.speedBoostSnd = new THREE.Audio(this.listener);
        this.speedBoostSnd.setBuffer(Global.assets['sounds']['SpeedBoost']['asset']);
        this.speedBoostSnd.setLoop(false); // Set whether the audio should loop
        this.speedBoostSnd.setVolume(0.5); // Set the volum

        this.invinsibleSnd = new THREE.Audio(this.listener);
        this.invinsibleSnd.setBuffer(Global.assets['sounds']['Invincible']['asset']);
        this.invinsibleSnd.setLoop(false); // Set whether the audio should loop
        this.invinsibleSnd.setVolume(0.5); // Set the volum
     
        this.timeDeductSnd = new THREE.Audio(this.listener);
        this.timeDeductSnd.setBuffer(Global.assets['sounds']['TimeBoost01']['asset']);
        this.timeDeductSnd.setLoop(false); // Set whether the audio should loop
        this.timeDeductSnd.setVolume(0.5); // Set the volum

        this.hitSnd = new THREE.Audio(this.listener);
        this.hitSnd.setBuffer(Global.assets['sounds']['Hit']['asset']);
        this.hitSnd.setLoop(false); // Set whether the audio should loop
        this.hitSnd.setVolume(0.5); // Set the volum
     
    }
}